import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewOnlyFieldComponent } from './components/view-only-field/view-only-field.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { MaterialsModule } from './materials/materials.module';
import { FeatureTabLayoutModule } from './components/feature-tab-layout/feature-tab-layout.module';
import { SavedFilterDialogModule } from './components/saved-filter-dialog';
import { DataCountCardModule } from './components/data-count-card';
import { UnCamelCasePipe } from './pipes/un-camel-case';
import { EventItemComponent } from './components/event-item/event-item.component';
import { TruncatePipe } from './pipes/truncate.pipe';
import { EventsPageComponent } from './components/events-page/events-page.component';
import { NgSelectOverrideComponent } from './components/ng-select-override/ng-select-override.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { EmployerCardComponent } from './components/cards/employer-card/employer-card.component';
import { LearnerCardComponent } from './components/cards/learner-card/learner-card.component';
import { OutlineViewOnlyFieldComponent } from './components/outline-view-only-field/outline-view-only-field.component';
import { DashIfEmptyPipe } from './pipes/dash-if-empty.pipe';
import { ReportsComponent } from './components/reports/reports.component';
import { RangePipe } from './pipes/range-pipe';
import { InputDebounceComponent } from './components/input-debounce/input-debounce.component';
import { TimeFormatFromMinsPipe } from './pipes/time-format-from-mins.pipe';
import { SendMessageFormComponent } from './components/send-message-form/send-message-form.component';
import { DndDirective } from './directives/dnd.directive';
import { WidgetDirective } from './directives/widget.directive';
import { FriendlyDatePipe } from './pipes/friendly-date.pipe';
import { YesNoPipe } from './pipes/yes-no.pipe';
import { InfoDialogComponent } from './components/info-dialog/info-dialog.component';
import { AdminListShellComponent } from './components/admin-list-shell/admin-list-shell.component';
import { AdminFilterSidebarComponent } from './components/admin-filter-sidebar/admin-filter-sidebar.component';
import { TableLoadingOverlayComponent } from './components/table-loading-overlay/table-loading-overlay.component';

@NgModule({
  declarations: [
    ViewOnlyFieldComponent,
    NavbarComponent,
    EventItemComponent,
    EventsPageComponent,
    NgSelectOverrideComponent,
    UnCamelCasePipe,
    TruncatePipe,
    RangePipe,
    LearnerCardComponent,
    EmployerCardComponent,
    OutlineViewOnlyFieldComponent,
    DashIfEmptyPipe,
    ReportsComponent,
    InputDebounceComponent,
    TimeFormatFromMinsPipe,
    SendMessageFormComponent,
    DndDirective,
    WidgetDirective,
    FriendlyDatePipe,
    YesNoPipe,
    InfoDialogComponent,
    AdminListShellComponent,
    AdminFilterSidebarComponent,
    TableLoadingOverlayComponent,
  ],
  imports: [
    CommonModule,
    MaterialsModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    CKEditorModule,
    FeatureTabLayoutModule,
    SavedFilterDialogModule,
    DataCountCardModule,
  ],
  exports: [
    ViewOnlyFieldComponent,
    EventItemComponent,
    NavbarComponent,
    EventsPageComponent,
    NgSelectOverrideComponent,
    UnCamelCasePipe,
    TruncatePipe,
    RangePipe,
    LearnerCardComponent,
    EmployerCardComponent,
    OutlineViewOnlyFieldComponent,
    DashIfEmptyPipe,
    ReportsComponent,
    InputDebounceComponent,
    TimeFormatFromMinsPipe,
    SendMessageFormComponent,
    DndDirective,
    WidgetDirective,
    FriendlyDatePipe,
    YesNoPipe,
    InfoDialogComponent,
    AdminListShellComponent,
    AdminFilterSidebarComponent,
    TableLoadingOverlayComponent,
    FeatureTabLayoutModule,
    SavedFilterDialogModule,
    DataCountCardModule,
  ],
})
export class SharedModule {}
